import { Box, Button, Chip, Divider, Grid, alpha, styled } from '@mui/material';
import { StylableTooltip } from 'components/common/CommonStyles';

export const CommentsHeaderWrapper = styled(Grid)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.common.white,
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(3),
  boxShadow: theme.shadows[10],
  zIndex: 10
}));

export const CommentsContentWrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.default
}));

export const CommentsFooterWrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(3),
  boxShadow: theme.shadows[24],
  zIndex: 10
}));

export const CommentCardWrapper = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2)
}));

export const CommentCurrentUserChip = styled(Chip)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.spacing(1.5)
}));

export const CommentTypeChip = styled(Chip, { shouldForwardProp: prop => !['internal'].includes(prop) })(({ theme, internal }) => ({
  backgroundColor: alpha(internal ? theme.palette.primary.main : theme.palette.warning.main, 0.1),
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.spacing(1.5)
}));

export const CommentRecipientsAnchor = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[900],
  backgroundColor: theme.palette.grey[200],
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'none',
  fontSize: theme.spacing(1.75),
  '&:hover': {
    backgroundColor: theme.palette.grey[200]
  }
}));

export const CommentRecipientsTooltip = styled(StylableTooltip)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
  fontSize: '16px',
  boxShadow: theme.shadows[10]
}));

export const CommentDocumentStateLabel = styled('span')(({ theme }) => ({
  color: theme.palette.grey[900],
  borderColor: theme.palette.grey[900],
  borderWidth: '1px',
  borderRadius: theme.spacing(0.5),
  borderStyle: 'solid',
  fontWeight: theme.typography.fontWeightBold,
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(2)
}));

export const CommentsDateDivider = styled(Divider)(({ theme }) => ({
  height: 'auto',
  backgroundImage: 'none',
  margin: theme.spacing(0)
}));

export const ParentCommentWrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  padding: theme.spacing(1),
  borderRadius: theme.spacing(0.5),
  borderLeft: `${theme.spacing(0.5)} solid ${theme.palette.grey[400]}`
}));

export const SendToOption = styled('li')(({ theme }) => ({
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(0.25)
}));
